<template>
  <div style="margin: auto; width: 500px;">
    <!-- 顶部导航栏 -->
    <div class="emailc-box flx-row-s-c">
      <div v-if="result != null && result" style="width: 100%;" class="flx-col-c-c">
        <div class="title">恭喜您，邮箱认证成功!</div>
        <div class="sub-tit">认证邮箱：{{ email }} <a href="/user/certify-email" class="b-form-font-button" style="margin-left: 33px;">查看</a></div>
      </div>
      <div v-if="result != null && !result" style="width: 100%;" class="flx-col-c-c">
        <div class="title">邮件认证失败!</div>
        <div class="sub-tit">认证邮箱：{{ email }}</div>
        <div style=" margin-top: 20px; text-align: center;">
          <span class="b-form-font-button" style="margin-top: 20px; cursor: pointer;" @click="resend(email)">重新发送认证邮箱</span>
        </div>
        <div  style="margin-top: 20px; font-size: 14px; text-align: center;">{{ reason }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { checkEmailKey, submitCertificatesEmail} from '@/server/data';
export default {
  name: 'emailc',
  data() {
    return {
      loading: false,
      result: null,
      reason: '',
      email: ''
    };
  },
  created() {
    this.check();
  },
  methods: {
    async check() {
      let key = this.$route.query.key;
      if (!key) {
        this.result = false;
        this.email = '';
        this.reason = '验证凭证不存在，请重试！';
        this.loading = false;
        return;
      }
      let params = {
        key: key
      };
      let res = await checkEmailKey(params);
      if (res.result) {
        this.result = res.data.result;
        this.email = res.data.email;
        this.reason = res.data.msg;
      }
      this.loading = false;
    },
    // 重发邮箱验证
    resend(email) {
      let params = {
        email: email
      };
      this.$Modal.confirm({
        title: '重发确认',
        content: '<p>确定重新发送认证邮件到</p><p>' + email + '？</p>',
        onOk: async () => {
          let res = await submitCertificatesEmail(params);
          if (res.code == 200) {
            this.$Message.info('认证邮箱已发送，请注意查收！');
          }
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.emailc-box {
  margin-top: 200px;
  width: 100%;

  .title {
    margin-top: 60px;
    font-size: 32px;
    font-weight: 600;
    text-align: center;
  }

  .sub-tit {
    margin-top: 40px;
    font-size: 32px;
    text-align: center;
  }

  .b-form-font-button {
    font-size: 28px;
    color: #f9521f;
  }
}
</style>
